swatchChangeProducts = [];
upsellChangeProducts = [];
productAddons = [];

const formDataToObject = (form) => {
    const setNestedValue = (obj, path, value) => {
        const parts = path.match(/[^\[\]]+/g);
        let current = obj;

        parts.forEach((part, index) => {
            if (index === parts.length - 1) {
                current[part] = value;
            } else {
                if (!current[part]) {
                    current[part] = isNaN(parts[index + 1]) ? {} : [];
                }
                current = current[part];
            }
        });
    }

    const formData = new FormData(form);
    const result = {};

    for (const [key, value] of formData.entries()) {
        setNestedValue(result, key, value);
    }

    return result;
}

const handleAddToCart = async (event, cart = {}, fromForm = false) => {

    if (fromForm) {
        event.preventDefault();
        event.stopPropagation();

        let formData = formDataToObject(cart);

        if (!formData.items) {
            cart = {
                items: [formData]
            };
        }
        else {
            cart = formData;
        }

        if (productAddons) {
            const productQuantity = Math.max(1, Math.ceil(Number(cart.items?.[0]?.quantity) || 1));
            for (let [productAddonKey, productAddon] of Object.entries(productAddons)) {
                productAddon.forEach(productAddonItem => {
                    cart.items.push({
                        id: productAddonItem.id,
                        quantity: productAddonItem.multiplyByProductQuantity
                            ? productAddonItem.quantity * productQuantity
                            : productAddonItem.quantity
                    })
                })
            }
        }
    }
    const cartDrawer = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    if (cartDrawer) {
        cart.sections = cartDrawer.getSectionsToRender().map((section) => section.id);
    }

    let response = {};
    try {
        response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(cart)
        });
        response = await response.json();

        if (cartDrawer) {
            cartDrawer.renderContents(response, { openCompleteLook: true });
            if (cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');
        }
    }
    catch (e) {
        console.error('Cart add api failed => ', e);
    }

    return response;
}

const ensureProductStylesheet = (root, assetName, markerAttribute) => {
    const sourceStylesheet = root.querySelector?.(`link[href*="${assetName}"]`);
    if (sourceStylesheet?.href && !document.head.querySelector(`link[${markerAttribute}]`)) {
        const stylesheet = document.createElement('link');
        stylesheet.rel = 'stylesheet';
        stylesheet.href = sourceStylesheet.href;
        stylesheet.setAttribute(markerAttribute, 'true');
        document.head.appendChild(stylesheet);
    }
}

const ensureVanityBuilderAssets = (root = document) => {
    const builder = root.querySelector?.('vanity-builder');
    const builderHost = root.querySelector?.('[data-vanity-builder-host]');
    if (!builder && !builderHost) return;

    ensureProductStylesheet(root, 'component-custom-product-info.css', 'data-custom-product-info-stylesheet');
    ensureProductStylesheet(root, 'component-vanity-builder.css', 'data-vanity-builder-stylesheet');

    if (builderHost) {
        const sourceLoader = root.querySelector('script[src*="component-vanity-builder-loader.js"]');
        const builderScriptSrc = sourceLoader?.dataset.builderScriptSrc;

        if (window.VanityBuilderLoader) {
            window.VanityBuilderLoader.configure(builderScriptSrc);
            window.VanityBuilderLoader.init(root);
            return;
        }

        if (!sourceLoader?.src || !builderScriptSrc) return;

        const initLoader = () => window.VanityBuilderLoader?.init(document);
        const existingLoader = document.getElementById('component-vanity-builder-loader-script');
        if (existingLoader) {
            if (existingLoader.dataset.loaded === 'true') {
                initLoader();
            } else {
                existingLoader.addEventListener('load', initLoader, { once: true });
            }
            return;
        }

        const loader = document.createElement('script');
        loader.id = 'component-vanity-builder-loader-script';
        loader.src = sourceLoader.src;
        loader.async = true;
        loader.fetchPriority = 'low';
        loader.dataset.builderScriptSrc = builderScriptSrc;
        loader.addEventListener(
            'load',
            () => {
                loader.dataset.loaded = 'true';
                initLoader();
            },
            { once: true },
        );
        loader.addEventListener('error', () => loader.remove(), { once: true });
        document.head.appendChild(loader);
        return;
    }

    if (customElements.get('vanity-builder') || window.__vanityBuilderScriptLoading) return;

    const vanityScript = root.querySelector('script[src*="component-vanity-builder.js"]');
    if (!vanityScript?.src) return;

    window.__vanityBuilderScriptLoading = true;
    const script = document.createElement('script');
    script.src = vanityScript.src;
    script.defer = true;
    script.setAttribute('data-vanity-builder-script', 'true');
    script.addEventListener('error', () => {
        window.__vanityBuilderScriptLoading = false;
    });
    document.body.appendChild(script);
}

const ensureCustomProductSizeAssets = (root = document) => {
    if (!root.querySelector?.('custom-product-size-calculator')) return;

    ensureProductStylesheet(root, 'component-custom-product-info.css', 'data-custom-product-info-stylesheet');
    ensureProductStylesheet(root, 'component-custom-product-size.css', 'data-custom-product-size-stylesheet');

    if (customElements.get('custom-product-size-calculator') || window.__customProductSizeScriptLoading) return;

    const customSizeScript = root.querySelector('script[src*="component-custom-product-size.js"]');
    if (!customSizeScript?.src) return;

    window.__customProductSizeScriptLoading = true;
    const script = document.createElement('script');
    script.src = customSizeScript.src;
    script.defer = true;
    script.setAttribute('data-custom-product-size-script', 'true');
    script.addEventListener('load', () => {
        window.__customProductSizeScriptLoading = false;
    });
    script.addEventListener('error', () => {
        window.__customProductSizeScriptLoading = false;
    });
    document.body.appendChild(script);
}

const ensureTileProductAssets = (root = document) => {
    if (!root.querySelector?.('[data-tile-calculator]')) return;

    ensureProductStylesheet(root, 'component-tile-product.css', 'data-tile-product-stylesheet');

    if (window.__ATS_TILE_PRODUCT_INITIALIZED__ || window.__tileProductScriptLoading) return;

    const tileProductScript = root.querySelector('script[src*="component-tile-product.js"]');
    if (!tileProductScript?.src) return;

    window.__tileProductScriptLoading = true;
    const script = document.createElement('script');
    script.src = tileProductScript.src;
    script.defer = true;
    script.setAttribute('data-tile-product-script', 'true');
    script.addEventListener('load', () => {
        window.__tileProductScriptLoading = false;
    });
    script.addEventListener('error', () => {
        window.__tileProductScriptLoading = false;
    });
    document.body.appendChild(script);
}

let productNavigation = null;
const productJsonCache = new WeakMap();

const beginProductNavigation = () => {
    productNavigation?.abort();
    productNavigation = new AbortController();
    const root = document.querySelector('[data-product-main]');
    root?.setAttribute('aria-busy', 'true');
    const buttons = Array.from(root?.querySelectorAll('add-to-cart-form [data-custom-add-to-cart-button]') || []);
    const states = buttons.map((button) => button.disabled);
    productNavigation.restoreButtons = () => buttons.forEach((button, index) => { button.disabled = states[index]; });
    productNavigation.signal.addEventListener('abort', productNavigation.restoreButtons, { once: true });
    buttons.forEach((button) => { button.disabled = true; });
    return productNavigation;
};

const finishProductNavigation = (navigation) => {
    if (productNavigation !== navigation) return;
    navigation.restoreButtons();
    productNavigation = null;
    const root = document.querySelector('[data-product-main]');
    root?.removeAttribute('aria-busy');
    root?.querySelectorAll('product-swatch [data-product-swatch]').forEach((swatch) => {
        swatch.classList.toggle('active-swatch', swatch.parentElement?.getAttribute('data-current-option') === 'true');
    });
};

const afterProductSelectionPaint = () => new Promise((resolve) => {
    requestAnimationFrame(() => requestAnimationFrame(() => setTimeout(resolve, 0)));
});

const handleProductHtmlUpdate = async (selector, variantId, navigation) => {
    // Cached and fetched sections share a cancellable render, after selection feedback paints.
    await afterProductSelectionPaint();
    if (navigation.signal.aborted) return false;
    let existingProductContainerEl = document.querySelector(selector);
    let sectionHtml = swatchChangeProducts[variantId]?.['section_html'];
    if (!existingProductContainerEl || !sectionHtml) return false;

    existingProductContainerEl.innerHTML = sectionHtml;
    ensureVanityBuilderAssets(existingProductContainerEl);
    ensureCustomProductSizeAssets(existingProductContainerEl);
    ensureTileProductAssets(existingProductContainerEl);
    window.okeWidgetApi?.initAllWidgets();
    document.dispatchEvent(new CustomEvent("theme:product-loaded"));
    return true;
}

const PRODUCT_SOFT_NAVIGATION_EVENT = 'ats_custom_app:product_soft_navigation';

const publishProductSoftNavigation = ({
    navigationKind,
    navigationSource,
    productId = null,
    variantId = null,
    variantTitle = null,
    optionName = null,
    optionValue = null,
} = {}) => {
    let productContainerEl = document.querySelector('[data-product-main] [data-product-container]');
    let productTitleEl = document.querySelector('[data-product-main] .product-title');
    let productTitle = productTitleEl?.textContent?.trim() || null;
    let analytics = window.Shopify?.analytics;
    if (typeof analytics?.publish !== 'function') return;

    try {
        let result = analytics.publish(PRODUCT_SOFT_NAVIGATION_EVENT, {
            path: window.location.pathname,
            pageTitle: productTitle,
            productId: productId || productContainerEl?.getAttribute('data-product-id') || null,
            variantId: variantId || productContainerEl?.getAttribute('data-variant-id') || null,
            productTitle,
            variantTitle,
            optionName,
            optionValue,
            navigationKind,
            navigationSource,
        });

        if (result && typeof result.catch === 'function') {
            result.catch(() => undefined);
        }
    }
    catch (_error) {
        // Analytics must never interrupt product navigation.
    }
}

const manageProductHtml = async (save = true) => {
    if (!window.location.pathname.includes('/products/')) return;

    let selector = '[data-product-main]';
    let existingProductContainerEl = document.querySelector(selector);
    if (!existingProductContainerEl) return;

    let productUrl = window.location.pathname;
    let variantId = existingProductContainerEl.querySelector('[data-product-container]')?.getAttribute('data-variant-id');

    let searchParams = new URLSearchParams(window.location.search);

    if (save) {
        if (!swatchChangeProducts.hasOwnProperty(variantId)) {
            swatchChangeProducts[variantId] = {};
        }
        swatchChangeProducts[variantId]['section_html'] = existingProductContainerEl.innerHTML;
    }
    else {
        const navigation = beginProductNavigation();
        let restoredProduct = false;
        variantId = searchParams.get('variant');
        try {
            if (swatchChangeProducts.hasOwnProperty(variantId) && (swatchChangeProducts[variantId]['section_html'] || null)) {
                restoredProduct = await handleProductHtmlUpdate(selector, variantId, navigation);
            }
        } finally {
            finishProductNavigation(navigation);
        }
        if (navigation.signal.aborted) return;
        variantId = existingProductContainerEl.querySelector('[data-product-container]')?.getAttribute('data-variant-id');

        if (restoredProduct) {
            publishProductSoftNavigation({
                navigationKind: 'history',
                navigationSource: 'browser_history',
                variantId,
            });
        }
    }

    searchParams.set('variant', variantId);
    history.replaceState(null, null, `${window.location.origin}${productUrl}?${searchParams.toString()}`);

    /*if (!save) {
        window.location.href = '';
    }*/
}

manageProductHtml();

window.addEventListener('popstate', () => manageProductHtml(false));

class ProductSwatch extends HTMLElement {
    constructor() {
        super();
        this.productUrl = this.getAttribute('data-product-url');
        this.sectionId = this.getAttribute('data-section-id');
        this.productId = this.getAttribute('data-product-id');
        this.variantId = this.getAttribute('data-variant-id');
        this.variantTitle = null;
        this.productSectionHandle = this.getAttribute('data-product-section-handle');
        this.isVariantSwatch = this.getAttribute('data-product-variant') === 'true';
        this.optionName = this.getAttribute('data-option-name');
        this.optionNameKey = this.normalizeOptionName(this.optionName);
        this.optionValue = this.getAttribute('data-option-value');
        this.optionPosition = this.getAttribute('data-option-position');
        this.productContainerSelector = '[data-product-main]';
        this.productRoot = this.closest(this.productContainerSelector) || document;
        this.swatchHoverUpdateEl = this.productRoot.querySelector(`[data-option-${this.optionNameKey}-label]`);
        this.selectedOptions = {};
        this.selectedOptionIds = [];
        this.selectedOptionsKey = '';

        if (this.productId) {
            this.product = document.querySelector(`#productJson_${this.productId}`)
            if (this.product) {
                if (!productJsonCache.has(this.product)) {
                    productJsonCache.set(this.product, JSON.parse(this.product.textContent));
                }
                this.product = productJsonCache.get(this.product);
            }
        }

        this.bindEvents();
    }

    normalizeOptionName(value) {
        return (value || '')
            .toString()
            .trim()
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '');
    }

    bindEvents() {
        let productSwatchEl = this.querySelector('[data-product-swatch]');
        productSwatchEl?.addEventListener('click', (event) => this.handleSwatchClick(event));
        productSwatchEl?.addEventListener('mouseenter', (event) => this.handleSwatchMouseOver(event));
        productSwatchEl?.addEventListener('mouseleave', (event) => this.handleSwatchMouseOut(event));
    }

    async handleSwatchClick(event) {
        event.preventDefault();
        event.stopPropagation();

        if (this.getAttribute('data-current-option') === 'true' && !productNavigation) return;

        if (this.isVariantSwatch) {
            let selectedOptionsEl = document.querySelectorAll('product-swatch[data-product-variant="true"] .active-swatch');
            this.selectedOptions = {};
            this.selectedOptionIds = [];
            selectedOptionsEl.forEach(selectedOptionEl => {
                if (selectedOptionEl.parentElement?.getAttribute('data-option-position') === this.optionPosition) {
                    this.selectedOptions[this.optionPosition] = this.optionValue;
                    this.selectedOptionIds.push(this.getAttribute('data-option-id'));
                }
                else {
                    this.selectedOptions[selectedOptionEl.parentElement?.getAttribute('data-option-position')] = selectedOptionEl.parentElement?.getAttribute('data-option-value');
                    this.selectedOptionIds.push(selectedOptionEl.parentElement?.getAttribute('data-option-id'));
                }
            });

            this.selectedOptionsKey = this.selectedOptionIds.join(',');

            let selectedVariant = this.product?.variants?.find(variant => {
                return (variant.option1 === null && (this.selectedOptions[1] || null) === null ? true : variant.option1 === (this.selectedOptions[1] || null))
                    && (variant.option2 === null && (this.selectedOptions[2] || null) === null ? true : variant.option2 === (this.selectedOptions[2] || null))
                    && (variant.option3 === null && (this.selectedOptions[3] || null) === null ? true : variant.option3 === (this.selectedOptions[3] || null))
            });

            if (selectedVariant) {
                this.variantId = selectedVariant.id;
                this.variantTitle = selectedVariant.title || null;
            }
        }

        this.parentElement?.querySelector('.active-swatch[data-product-swatch]')?.classList?.remove('active-swatch');
        this.querySelector('[data-product-swatch]')?.classList?.add('active-swatch');

        if (this.variantId) {
            if (!swatchChangeProducts.hasOwnProperty(this.variantId)) {
                swatchChangeProducts[this.variantId] = {};
            }
        }
        else {
            if (!swatchChangeProducts.hasOwnProperty(this.selectedOptionsKey)) {
                swatchChangeProducts[this.selectedOptionsKey] = {};
            }
        }

        const navigation = beginProductNavigation();
        try {
            let productUpdated = false;
            if (
                this.variantId
                && swatchChangeProducts.hasOwnProperty(this.variantId)
                && (swatchChangeProducts[this.variantId]['section_html'] || null)
            ) {
                productUpdated = await handleProductHtmlUpdate(this.productContainerSelector, this.variantId, navigation);
            }
            else if (
                swatchChangeProducts.hasOwnProperty(this.selectedOptionsKey)
                && (swatchChangeProducts[this.selectedOptionsKey]['section_html'] || null)
            ) {
                productUpdated = await handleProductHtmlUpdate(this.productContainerSelector, this.selectedOptionsKey, navigation);
            }
            else {
                productUpdated = await this.handleProductUpdate(navigation);
            }

            if (!productUpdated) return;

            let searchParams = new URLSearchParams(window.location.search);
            if (this.variantId) {
                searchParams.set('variant', this.variantId);
                history.pushState(null, null, `${window.location.origin}${this.productUrl}?${searchParams.toString()}`);
            }
            else {
                searchParams.delete('variant');
                history.pushState(null, null, `${window.location.origin}${this.productUrl}?${searchParams.toString()}`);
            }

            publishProductSoftNavigation({
                navigationKind: this.isVariantSwatch ? 'variant' : 'linked_product',
                navigationSource: 'product_swatch',
                variantId: this.variantId,
                variantTitle: this.variantTitle,
                optionName: this.optionName,
                optionValue: this.optionValue,
            });
        } finally {
            finishProductNavigation(navigation);
        }
    }

    async handleProductUpdate(navigation) {
        try {
            let sectionHtml = '';

            if (this.productSectionHandle) {
                const sectionUrl = new URL(this.productUrl, window.location.origin);
                sectionUrl.searchParams.set('section_id', this.productSectionHandle);
                if (this.selectedOptionsKey) {
                    sectionUrl.searchParams.set('option_values', this.selectedOptionsKey);
                }

                const sectionResponse = await fetch(sectionUrl, { signal: navigation.signal });
                if (!sectionResponse.ok) {
                    throw new Error(`Product section request failed with status ${sectionResponse.status}`);
                }
                sectionHtml = await sectionResponse.text();
            }
            else {
                let product = await fetch(`${this.productUrl}?sections=${this.sectionId}&option_values=${this.selectedOptionsKey}`, { signal: navigation.signal });
                product = await product.json();
                sectionHtml = product[this.sectionId];
            }

            if (!sectionHtml) throw new Error('Product section response was empty');

            let productSectionEl = (new DOMParser()).parseFromString(sectionHtml, 'text/html');
            let newProductSectionEl = productSectionEl.querySelector(this.productContainerSelector);
            if (newProductSectionEl) {
                swatchChangeProducts[this.variantId ? this.variantId : this.selectedOptionsKey]['section_html'] = newProductSectionEl.innerHTML;
                return await handleProductHtmlUpdate(this.productContainerSelector, this.variantId ? this.variantId : this.selectedOptionsKey, navigation);
            }

            return false;
        }
        catch (e) {
            if (navigation.signal.aborted) return false;
            console.error('Error in product update section api => ', e);
            return false;
        }
    }

    handleSwatchMouseOver(event) {
        if (!this.swatchHoverUpdateEl) return;

        this.swatchHoverUpdateEl.innerHTML = this.optionValue;
    }

    handleSwatchMouseOut(event) {
        if (!this.swatchHoverUpdateEl) return;

        let currentActiveSwatchEl = this.productRoot.querySelector(`product-swatch[data-option-name="${this.optionNameKey}"] .active-swatch`);
        if (currentActiveSwatchEl && currentActiveSwatchEl.parentElement) {
            this.swatchHoverUpdateEl.innerHTML = currentActiveSwatchEl.parentElement?.getAttribute('data-option-value');
            return;
        }

        let defaultOptionValue = this.swatchHoverUpdateEl.getAttribute('data-default-option-value');
        if (defaultOptionValue) this.swatchHoverUpdateEl.textContent = defaultOptionValue;
    }
}

customElements.define('product-swatch', ProductSwatch);

class AddToCartForm extends HTMLElement {
    constructor() {
        super();
        for (let [productAddonKey, productAddon] of Object.entries(productAddons)) {
            productAddons[productAddonKey] = [];
        }

        this.quantityEl = this.querySelector('input[name="quantity"]');
        this.quantityPlusButtonEl = this.querySelector('[data-quantity-plus-button]');
        this.quantityMinusButtonEl = this.querySelector('[data-quantity-minus-button]');

        this.bindEvents();
    }

    bindEvents() {
        let cartFormEl = this.querySelector('form[action*="/cart/add"][data-custom-add-to-cart]');
        cartFormEl?.addEventListener('submit', async (event) => {
            let addToCartButtonEl = this.querySelector('[data-custom-add-to-cart-button]');
            let addToCartLoaderEl = this.querySelector('[data-custom-add-to-cart-loader]');

            addToCartLoaderEl?.classList?.remove('d-none');
            addToCartButtonEl?.classList?.add('custom-loading');

            try {
                await handleAddToCart(event, cartFormEl, true)
            }
            catch (e) {
                console.error(e);
            }

            addToCartLoaderEl?.classList?.add('d-none');
            addToCartButtonEl?.classList?.remove('custom-loading');
        });

        if (this.quantityEl && this.quantityEl.valueAsNumber <= 1) {
            this.quantityMinusButtonEl?.setAttribute('disabled', true);
        }

        this.quantityPlusButtonEl?.addEventListener('click', (event) => this.handleQuantityIncrease(event))
        this.quantityMinusButtonEl?.addEventListener('click', (event) => this.handleQuantityDecrease(event))
    }

    handleQuantityIncrease(event) {
        if (!this.quantityEl) return;

        this.quantityEl.value = this.quantityEl.valueAsNumber + 1;
        if (this.quantityEl.valueAsNumber > 1) {
            this.quantityMinusButtonEl?.removeAttribute('disabled');
        }
    }

    handleQuantityDecrease(event) {
        if (!this.quantityEl) return;

        this.quantityEl.value = this.quantityEl.valueAsNumber - 1;

        if (this.quantityEl.valueAsNumber <= 1) {
            this.quantityMinusButtonEl?.setAttribute('disabled', true);
        }
    }
}

customElements.define('add-to-cart-form', AddToCartForm);
